import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = { 
  topImage: "/images/service/sr-d-1-1-csd.jpg",
  heading: "Custom Software Solutions",
  description: `Our Custom Software Solutions are designed to deliver scalable, secure, and highly tailored applications that meet your unique business requirements. From initial concept to full deployment, we develop software that enhances efficiency, automates workflows, and supports your digital transformation journey. Whether it's desktop applications, enterprise platforms, or cloud-based solutions, we focus on innovation, quality, and long-term impact.`,

  middleImage: "/images/service/sr-d-1-2-csm.jpg",
  features: [
    "Tailored Software Solutions for Your Business",
    "End-to-End Development (Design to Deployment)",
    "Cross-Platform Compatibility",
    "Ongoing Maintenance & Support",
  ],

  challengeHeading: "Challenges in Custom Software Development",
  challengeParagraphs: [
    `Accurately understanding requirements and designing software architecture that aligns with your business goals can be challenging. Custom development also requires thorough testing, scalability planning, and seamless integration with existing systems.`,
    `Our team adopts a collaborative approach, delivering adaptable solutions and continuous support to overcome these challenges and provide long-term value for your organization.`,
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg",
  ],
};

const CustomSoftwareSolutions = () => (
  <Fragment>
    <Seo
      title="Custom Software Solutions | Tech Ayukta"
      description="Tech Ayukta provides Custom Software Solutions tailored to your business needs with secure, scalable, and innovative software."
      keywords="Custom Software Solutions, Enterprise Software, Business Applications, Tech Ayukta, Software Development"
      canonical="https://www.techayukta.com/services/custom-software-solutions"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Custom Software Solutions"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default CustomSoftwareSolutions;
